import { useEffect, useRef } from 'react';

const useEventListener = <K extends keyof WindowEventMap>(
    eventName: K,
    callback: (event: WindowEventMap[K]) => void,
    element: Window | Document | HTMLElement | null = window
) => {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        if (element === null) return;

        const handler = (event: Event) => {
            callbackRef.current(event as WindowEventMap[K]) ;
        };

        element.addEventListener(eventName, handler);

        return () => element.removeEventListener(eventName, handler);
    }, [eventName, element]);
};

export default useEventListener;
